import React, { Fragment, useState } from "react";

// External component imports
import {
    Paper,
    List,
    Typography,
    Container,
    Accordion,
    AccordionSummary,
    Divider,
    AccordionDetails,
    ListItem,
    Dialog,
    Button,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import { sections } from "../context/guideText";

export default function SiteGuide() {
    function importImages(context) {
        let images = {};
        context.keys().forEach((item, index) => {
            images[item] = context(item);
        });
        return images;
    }

    const images = importImages(
        require.context("../images/guide_screenshots/")
    );

    // State and function to handle the image dialog: when the small image is is clicked
    // this opens a dialog with the fullsize image
    const [imageOpen, setImageOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");

    const handleImageOpen = (image) => {
        setSelectedImage(image);
        setImageOpen(true);
    };
    const handleImageClose = () => {
        setImageOpen(false);
    };

    function ItemConstructor(item) {
        // Takes an object that is either a list, a text item or an image and return an
        // appropriate component
        const type = item.type;

        if (type === "text") {
            // make appropriate text item
            let variant = "";
            let paragraph = false;
            if (item.styling === "paragraph") {
                variant = "body1";
                paragraph = true;
            } else if (item.styling === "subheader") {
                variant = "h6";
            }
            return (
                <Typography variant={variant} paragraph={paragraph}>
                    {item.content}
                </Typography>
            );
        } else if (type === "orderedList") {
            // make a list here
            return (
                <List sx={{ paddingLeft: 3 }}>
                    {item.listItems.map((listItem) => (
                        <ListItem sx={{ p: 0 }} key={listItem.number}>
                            <Typography>
                                {listItem.number}. {listItem.text}
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            );
        } else if (type === "image") {
            // make image with button to show dialog with fullsize image
            return (
                <Button onClick={() => handleImageOpen(item.image)}>
                    <img
                        alt={item.image}
                        src={images["./" + item.image]}
                        style={{ maxWidth: "100%", border: "1px solid black" }}
                    />
                </Button>
            );
        }
    }

    function AccordionConstructor(section) {
        // takes a 'section' from the data object and creates a filled accordion element
        const title = section.title;
        let expandAtLoad = false;

        if (title === "Navigating within the website") {
            expandAtLoad = true;
        }

        return (
            <Accordion defaultExpanded={expandAtLoad} sx={{ boxShadow: 0 }}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="h5">{title}</Typography>
                </AccordionSummary>
                <Divider />
                <AccordionDetails component={Paper}>
                    <Container maxWidth={"md"}>
                        {section.content.map((item, index) => (
                            <Fragment key={index}>
                                {ItemConstructor(item)}
                            </Fragment>
                        ))}
                    </Container>
                </AccordionDetails>
            </Accordion>
        );
    }

    return (
        <>
            <Dialog open={imageOpen} onClose={handleImageClose} maxWidth="xl">
                <img src={images["./" + selectedImage]} alt="magnification" />
            </Dialog>

            <Container>
                <Paper sx={{ padding: 4 }}>
                    {sections.map((section) => (
                        <Fragment key={section.title}>
                            {AccordionConstructor(section)}
                        </Fragment>
                    ))}
                </Paper>
            </Container>
        </>
    );
}
